import React from "react";

const EconomicSegmentBreakdown = ({ segmentData }) => (
    <section className="card">
        <h3>Economic Segment Breakdown</h3>
        <table>
            <thead>
                <tr>
                    <th>Segment</th>
                    <th>Budget</th>
                    <th>Spent</th>
                </tr>
            </thead>
            <tbody>
                {segmentData.map((row, i) => (
                    <tr key={i}>
                        <td>{row.name}</td>
                        <td>{row.budget.toLocaleString()}</td>
                        <td>{row.spent.toLocaleString()}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </section>
);

export default EconomicSegmentBreakdown;